import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value ? aed(value) : "";
}

async function buildDoc(title, report, metaHtml, bodyHtml) {
  const company = await resolveReportLetterhead({ branchId: report?.branch_id, allBranches: report?.all_branches });
  return buildReportDocument({
    title,
    company,
    metaHtml,
    bodyHtml,
  });
}

export async function printAccountBook(report, title, options = {}) {
  if (!report?.account) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  const rows = (withBranch.entries || [])
    .map(
      (e) => `
      <tr>
        <td>${e.voucher_date || ""}</td>
        <td class="mono">${e.voucher_number || ""}</td>
        <td>${e.particulars || e.narration || ""}</td>
        <td class="num">${cell(e.receipt)}</td>
        <td class="num">${cell(e.payment)}</td>
        <td class="num">${aed(e.balance)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildDoc(
    title,
    withBranch,
    `<div><strong>Account:</strong> ${escapeReportHtml(withBranch.account.code)} — ${escapeReportHtml(withBranch.account.name)}</div>
     ${periodMeta(withBranch)}`,
    `<table>
      <thead>
        <tr><th>Date</th><th>Voucher</th><th>Particulars</th><th>Receipt</th><th>Payment</th><th>Balance</th></tr>
      </thead>
      <tbody>
        <tr><td colspan="3"><em>Opening balance</em></td><td></td><td></td><td class="num">${aed(withBranch.opening_balance)}</td></tr>
        ${rows}
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">Closing</th>
          <th class="num">${aed(withBranch.total_receipts)}</th>
          <th class="num">${aed(withBranch.total_payments)}</th>
          <th class="num">${aed(withBranch.closing_balance)}</th>
        </tr>
      </tfoot>
    </table>`,
  );

  return openReportPrint(html);
}

export async function printDayBook(report, title = "Day Book", options = {}) {
  if (!report) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  const rows = (withBranch.entries || [])
    .map(
      (e) => `
      <tr>
        <td class="mono">${e.voucher_number}</td>
        <td>${e.voucher_type}</td>
        <td class="mono">${e.account_code}</td>
        <td>${e.account_name}</td>
        <td>${e.narration || e.party_name || ""}</td>
        <td class="num">${cell(e.debit)}</td>
        <td class="num">${cell(e.credit)}</td>
      </tr>`,
    )
    .join("");

  const html = await buildDoc(
    title,
    withBranch,
    `<div><strong>Date:</strong> ${escapeReportHtml(withBranch.date)} · <strong>Vouchers:</strong> ${withBranch.voucher_count}</div>`,
    `<table>
      <thead>
        <tr><th>Voucher</th><th>Type</th><th>Code</th><th>Account</th><th>Particulars</th><th>Debit</th><th>Credit</th></tr>
      </thead>
      <tbody>${rows}</tbody>
      <tfoot>
        <tr>
          <th colspan="5">Totals</th>
          <th class="num">${aed(withBranch.total_debit)}</th>
          <th class="num">${aed(withBranch.total_credit)}</th>
        </tr>
      </tfoot>
    </table>`,
  );

  return openReportPrint(html);
}
